// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilGrayXXLight":"#F9F9FA","wrapper":"style_wrapper__2mCs7","image":"style_image__3nWnj","loader":"style_loader__38zi_"};